import { withErrorBoundary } from "@sentry/nextjs";
import cn from "classnames";
import { FC } from "react";
import styled from "styled-components";
import { Link } from "components";
import { PortfolioTemplate } from "../types";
import { Chart } from "./Chart";

type Props = {
  portfolio: PortfolioTemplate;
  active: boolean;
  className?: string;
};

export const Selector: FC<Props> = withErrorBoundary(({ portfolio, active, className = "" }) => {
  return (
    <StyledSelector className={cn("Selector", className, {})}>
      <Link
        href={`/portfolios/${portfolio.slug}`}
        scroll={false}
        className={cn("Selector__link", {
          Selector__link_active: active,
        })}
      >
        <Chart transition={800} percent={portfolio.distribution.bond.scalar * 100 || 0} className="Selector__chart" />
        <div className="Selector__allocation Font_24_32_450">
          {Math.round(portfolio.distribution.stock.scalar * 100)}/{Math.round(portfolio.distribution.bond.scalar * 100)}
        </div>
      </Link>
    </StyledSelector>
  );
}, {});

const StyledSelector = styled.li`
  .Selector__link {
    width: 104px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 16px 0;
    background: none;
    border: none;
    cursor: pointer;
  }

  .Selector__link_active {
    border-radius: 8px;
    box-shadow: inset 0 0 0 1px rgb(85 50 250 / 48%);
    background: rgb(85 50 250 / 8%);
  }

  .Selector__chart {
    width: 40px;
    height: 40px;
  }

  .Selector__allocation {
    margin-top: 16px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    .Selector__link {
      width: 90px;
    }
  }
`;
